import { render } from "./GlobalError.vue?vue&type=template&id=52398786&scoped=true"
import script from "./GlobalError.vue?vue&type=script&lang=js"
export * from "./GlobalError.vue?vue&type=script&lang=js"

import "./GlobalError.vue?vue&type=style&index=0&id=52398786&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52398786"]])

export default __exports__